import React from 'react';
import PropTypes from 'prop-types';
import EventCard from './EventCard';

function containRussianPlayers(pl) {
    let find = false;
    if (pl.length >= 3) {
        pl.forEach((item) => {
            if (item.country === 'Россия') find = true;
        });
    }
    return find;
}


class EventsLists extends React.Component {
    static propTypes = {
        items: PropTypes.instanceOf(Array).isRequired,
        full: PropTypes.instanceOf(Object).isRequired,
        nextSlide: PropTypes.instanceOf(Function).isRequired,
        prevSlide: PropTypes.instanceOf(Function).isRequired,
        limits: PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            isFull: false
        };
        this.toggleFullList = this.toggleFullList.bind(this);
    }

    componentWillReceiveProps() {
        this.setState({
            isFull: false
        });
    }

    getItemsWithStatus(status, sortRevers = 1) {
        let result = this.props.items.filter(item =>
            item.name.indexOf('Положение команд') + 1 === 0
            && item.name.indexOf('Таблица') + 1 === 0
            && item.ch.comment.indexOf('Квалификация отменена') + 1 === 0);
        result = result.sort(
            (a, b) => (sortRevers * ((a.pub_date > b.pub_date) - (b.pub_date > a.pub_date))));
        return result;
    }

    getRussianMedals(sortRevers = 1) {
        let result = this.props.items.filter(item =>
            item.ch.flags.is_summary === 1
            && item.ch.flags.is_played
            && containRussianPlayers(item.ch.result.top));
        result = result.sort(
            (a, b) => (sortRevers * ((a.pub_date > b.pub_date) - (b.pub_date > a.pub_date))));
        return result;
    }

    toggleFullList() {
        if (this.state.isFull) {
            window.scrollTo(0, 0);
        }
        this.setState({
            isFull: !this.state.isFull
        });
    }

    render() {
        let printItems = this.getRussianMedals();
        printItems = [...printItems, ...this.getItemsWithStatus('Окончено', -1)];
        const itemsCount = printItems.length;
        if (this.state.isFull === false) {
            printItems = printItems.splice(0, this.props.limits);
        }
        return (
            <div className="calendar__events">
                <div className="calendar__buttons">
                    <button className="prev" onClick={this.props.prevSlide}><svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#arrow--calendar" ></use>' }} /></button>
                    <button className="next" onClick={this.props.nextSlide}><svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#arrow--calendar" ></use>' }} /></button>
                </div>
                <div className="calendar__events__list">
                    {printItems.map(item => <EventCard data={item} key={`event_card_${item.id}_${item.last_modified}`} full={this.props.full} />)}
                </div>
                {itemsCount > this.props.limits ? (<div className={`calendar__events__button ${this.state.isFull ? 'active' : ''}`}><button onClick={this.toggleFullList}><svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-card" ></use>' }} /> {this.state.isFull ? 'Скрыть' : 'События за весь день'}</button></div>) : ''}
            </div>
        );
    }
}

export default EventsLists;



// WEBPACK FOOTER //
// ./src/components/Calendar/EventsLists.jsx